<template>
  <section class="insufficient-signal-view">
    <header class="insufficient-signal-view__header">
      <p class="insufficient-signal-view__eyebrow">Signal check</p>
      <h4 class="insufficient-signal-view__title">{{ status }}</h4>
      <p class="insufficient-signal-view__cause">{{ cause }}</p>
    </header>

    <section v-if="evidenceReviewed" class="insufficient-signal-view__card">
      <p class="insufficient-signal-view__label">What was reviewed</p>
      <p class="insufficient-signal-view__text">{{ evidenceReviewed }}</p>
    </section>

    <section v-if="suggestedActions.length" class="insufficient-signal-view__card">
      <p class="insufficient-signal-view__label">What to do next</p>
      <ul class="insufficient-signal-view__list">
        <li v-for="(action, index) in suggestedActions" :key="`suggestion-${index}`">
          {{ action }}
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
export default {
  name: 'InsufficientSignalView',
  props: {
    status: {
      type: String,
      default: 'Not enough evidence to generate this report',
    },
    cause: {
      type: String,
      default: '',
    },
    evidenceReviewed: {
      type: String,
      default: '',
    },
    suggestedActions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.insufficient-signal-view {
  display: flex;
  flex-direction: column;
  gap: $space-4;
}

.insufficient-signal-view__header,
.insufficient-signal-view__card {
  border: 1px solid rgba($color-primary, 0.2);
  border-radius: $radius-md;
  background: rgba($color-primary, 0.03);
  padding: $space-3;
}

.insufficient-signal-view__eyebrow,
.insufficient-signal-view__label {
  margin: 0 0 $space-1;
  font-size: $font-size-xs;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $color-primary-dark;
}

.insufficient-signal-view__title {
  margin: 0;
}

.insufficient-signal-view__cause,
.insufficient-signal-view__text {
  margin: $space-2 0 0;
}

.insufficient-signal-view__list {
  margin: 0;
  padding-left: 1.2rem;
}

.insufficient-signal-view__list li + li {
  margin-top: $space-2;
}
</style>
